import React from 'react'
import logo from '../images/logo.svg'
import { NavLink } from 'react-router-dom'
import { motion } from "framer-motion"

const Header = () => {
    return (
        <motion.header
            initial={{ opacity: 0, y: -180 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
                ease: [0.6, 0.01, -0.05, 0.95],
                duration: 1,
                delay: 0.3,
            }}
            className='z-9999 px-4 md:px-[7.875em] absolute top-0 left-0 right-0'>

            <div className='flex items-center justify-between border-b-[1px] border-b-line/20 pb-4 pt-8'>
                <img src={logo} alt="logo" className='hover:animate-pulse' />
                <nav >
                    <ul className='flex items-center space-x-4 md:space-x-8 uppercase'>
                        <li><NavLink to="/" className='opacity-60 tracking-[.25em] hover:opacity-100'>Home</NavLink></li>
                        <li><NavLink to="/resume" className='opacity-60 tracking-[.25em] hover:opacity-100'>resume</NavLink></li>
                        <li><NavLink to="/work" className='opacity-60 tracking-[.25em] hover:opacity-100'>work</NavLink></li>
                    </ul>
                </nav>
            </div>
        </motion.header>
    )
}

export default Header
